import React from "react";
import * as Flex from "@twilio/flex-ui";
import Rollbar from "rollbar";
import packageJson from '../package.json';
global.appVersion = packageJson.version;


const renderFlexContextProvider = (manager) => {
  return <Flex.ContextProvider manager={manager}>
            <Flex.RootContainer />
          </Flex.ContextProvider>
}

class App extends React.Component {
  constructor(props) {
    super(props);

    const { manager } = this.props;
    const store = manager.store.getState();

    this.state = {
      rollbar: new Rollbar({
        accessToken: `${manager.configuration.rollbarAccessToken}`,
        captureUncaught: true,
        captureUnhandledRejections: true,
        environment: `${manager.configuration.environment}`,
        payload: {
          client: { 
            javascript: { 
              code_version: `${packageJson.version}` 
            }
          },
          person: {
            id: `${store.flex.worker.attributes.azure_user_id}`,
            username: `${store.flex.worker.attributes.contact_uri}`,
            email: `${store.flex.worker.attributes.email}`
          }
        }
      })
    };
  }

  render() {
    const { manager } = this.props;

    if (!manager) {
      return null;
    }

    return (
      renderFlexContextProvider(manager)
    );
  }
}

export default App;
